/* eslint-disable no-console */
import { isProductionEnv } from './environment';

const loggerLevelWrapper =
  (logFn: (...args: any) => void) =>
  (...msgs: any[]) => {
    if (!isProductionEnv()) {
      logFn(...msgs);
    }
  };

const log = (...msgs: any[]) => {
  console.log(...msgs);
};

const debug = (...msgs: any[]) => {
  console.debug(...msgs);
};

const info = (...msgs: any[]) => {
  console.info(...msgs);
};

const trace = (...msgs: any[]) => {
  console.trace(...msgs);
};

const warn = (...msgs: any[]) => {
  console.warn(...msgs);
};

const error = (...msgs: any[]) => {
  console.error(...msgs);
};

export const logger = {
  log: loggerLevelWrapper(log),
  debug: loggerLevelWrapper(debug),
  info: loggerLevelWrapper(info),
  trace,
  warn,
  error,
};
